
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateUser",
      resolverType: "mutation",
      routePath: "/updateUser",
      httpMethod: "POST",
    });
  